import { useScrolled } from "@/hooks/useScrollSpy";

export default function BackToTop() {
  const visible = useScrolled(600);

  if (!visible) return null;

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer shadow-lg"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </a>
  );
}